import { ImageBannerData, PromotionDisplayType } from "src/types/graphql.d";

export function filterExpiredImageBannerDeals(
  brands: ImageBannerData[]
): ImageBannerData[] {
  if (!brands || brands.length === 0) {
    return [];
  }

  return brands.filter((item) => {
    const endDate = new Date(item?.end_date);

    return item?.display_type === PromotionDisplayType.LightningDeal
      ? endDate.getTime() - 1000 > Date.now()
      : true;
  });
}

export function filterExpiredMaketingBlocks(
  banner: ImageBannerData[]
): ImageBannerData[] {
  if (!banner || banner.length === 0) {
    return [];
  }

  return banner.filter((item) => {
    const endDate = new Date(item.end_date);

    const promotionTypes: PromotionDisplayType[] = [
      PromotionDisplayType.LightningDeal,
      PromotionDisplayType.FlashSale,
    ];

    return promotionTypes.includes(item.display_type as PromotionDisplayType)
      ? endDate.getTime() - 1000 > Date.now()
      : true;
  });
}
